import { isValidContactPhone } from "./contact-validation.js";
import { sessionRequest } from "./cms/auth.js";
import { initSite } from "./site.js";
import { getBranchList } from "./cms/store.js";

await initSite();
populateBranchSelect();

function populateBranchSelect() {
  const select = document.getElementById("branch");
  if (!select) return;

  const placeholder = select.querySelector('option[value=""]')?.textContent || "בחרו סניף";
  select.innerHTML = `<option value="" disabled selected>${placeholder}</option>`;

  getBranchList().forEach((branch) => {
    const name = branch.branch?.trim();
    if (!name) return;

    const option = document.createElement("option");
    option.value = name;
    option.textContent = name;
    select.appendChild(option);
  });
}

const form = document.getElementById("contactForm");
const errorEl = document.getElementById("form-error");
const successEl = document.getElementById("form-success");
const submitBtn = document.getElementById("submit-btn");

form?.addEventListener("submit", async (event) => {
  event.preventDefault();
  hideMessages();

  const name = document.getElementById("name").value.trim();
  const email = document.getElementById("email").value.trim();
  const phone = document.getElementById("phone").value.trim();
  const content = document.getElementById("content").value.trim();
  const branchSelect = document.getElementById("branch");
  const branch = branchSelect.value;

  if (!name || !email || !phone || !branch || !content) {
    showError("נא למלא את כל השדות.");
    return;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError("כתובת האימייל אינה תקינה.");
    return;
  }

  if (!isValidContactPhone(phone)) {
    showError("מספר הטלפון אינו תקין.");
    return;
  }

  submitBtn.disabled = true;
  submitBtn.textContent = "שולח...";

  try {
    await sessionRequest("./api/contact.php", { name, email, phone, branch, content });
    form.reset();
    showSuccess("ההודעה נשלחה. נחזור אליכם בהקדם.");
  } catch {
    showError("שליחת ההודעה נכשלה. נסו שוב או התקשרו *2395.");
  } finally {
    submitBtn.disabled = false;
    submitBtn.textContent = "שליחה";
  }
});

function showError(message) {
  errorEl.textContent = message;
  errorEl.classList.add("is-visible");
}

function showSuccess(message) {
  successEl.textContent = message;
  successEl.classList.add("is-visible");
}

function hideMessages() {
  errorEl.classList.remove("is-visible");
  successEl.classList.remove("is-visible");
}
